module.exports = __webpack_public_path__ + "static/broadcast-button-03@3x-5bee75d604be66336ad98fb61e5e21db.png";